import React, { useEffect, useState } from "react";
import Sidebar from "../sidebar/sidebar";
import { FaCheck, FaTimes } from "react-icons/fa";
import { getList, updateData } from "../../hooks/api/utils";

const Chatconfiguration = () => {
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    getList("/chatbot/messages/", setLoading, setMessages);
  }, []);

  const handleEdit = (item) => {
    setEditId(item.id);
    setFormData({
      state_name: item.state_name,
      message_text: item.message_text,
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = (id) => {
    setLoading(true);
    updateData(
      "/chatbot/messages/",
      id,
      setLoading,
      formData,
      (res) => {
        setMessages((prev) =>
          prev.map((msg) => (msg.id === id ? { ...msg, ...formData } : msg))
        );
      },
      ""
    );
    setEditId(null);
  };

  const formatStateName = (str) => {
    if (!str) return "";
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
      <div className="rightContent">
        <div className="viewMain">
          <div className="row">
            <div className="col-md-12 bg-white left-col p-3 rounded shadow-sm">
              <h4 className="fw-bold mb-4">Chatbot Configuration</h4>

              {loading && <p>Loading...</p>}

              <div className="accordion" id="chatbotAccordion">
                {messages?.map((item) => (
                  <div
                    className="accordion-item border-0 mb-3 rounded shadow-sm overflow-hidden p-3"
                    key={item.id}
                  >
                    <h2 className="accordion-header" id={`heading-${item.id}`}>
                      <button
                        className="accordion-button collapsed fw-semibold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${item.id}`}
                      >
                        {formatStateName(item.state_name)}
                      </button>
                    </h2>
                    <div
                      id={`collapse-${item.id}`}
                      className="accordion-collapse collapse"
                      data-bs-parent="#chatbotAccordion"
                    >
                      <div className="accordion-body bg-white">
                        {editId === item.id ? (
                          <div className="p-2">
                            <div className="mb-3">
                              <label className="form-label fw-semibold text-secondary">
                                Message Text
                              </label>
                              <textarea
                                name="message_text"
                                className="form-control rounded"
                                rows="3"
                                value={formData.message_text}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="d-flex gap-2">
                              <button
                                className="blue_btn d-flex align-items-center gap-1"
                                onClick={() => handleSave(item.id)}
                              >
                                <FaCheck /> Save
                              </button>
                              <button
                                className="transparent_btn d-flex align-items-center gap-1"
                                onClick={() => setEditId(null)}
                              >
                                <FaTimes /> Cancel
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex justify-content-between align-items-start">
                            <div className="w-75">
                              <p className="text-muted mb-1">
                                <strong>Message:</strong> {item.message_text}
                              </p>
                            </div>
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() => handleEdit(item)}
                            >
                              <img
                                src="images/pencilIcon.svg"
                               
                                className="img-fluid"
                                alt="edit"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
           
          </div>
        </div>
      </div>
  );
};

export default Chatconfiguration;
